import {API} from "@/Composables/api";

const storeConversationParticipants = async (conversation, formData, params = {}) => {
    return API.post(route("conversations.participants.add", {conversation}), params, formData);
};

const toggleConversationParticipant = async (conversation, participant, params = {}) => {
    return API.put(route("conversations.participants.toggle", {conversation, participant}), params);
};

const removeConversationParticipant = async (conversation, participant, params = {}) => {
    return API.delete(route("conversations.participants.remove", {conversation, participant}), params);
};

export {storeConversationParticipants, toggleConversationParticipant, removeConversationParticipant};
